import React, { useState, useEffect } from 'react';

import Select from 'react-select';

import { validateFormField } from 'Helpers/formValidation';
import { listOfResources, multiSelectConfigs, onChangeUserAssociations, resourcesIds } from 'Helpers/multi-select';

import FormInput from 'CommonComponents/FormInput';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';
import SelectInput from 'CommonComponents/SelectInput';

export default function SupportUserInvite(props) {
    const isOrganisationUser = () => {
        return props.type && props.type === 'organisation';
    };

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [number_hours, setNumberHours] = useState(24);
    const [userId, setUserId] = useState('');
    const [rolesData, setRolesData] = useState([]);

    const defaultErrors = isOrganisationUser()
        ? {
              firstName: null,
              lastName: null,
              email: null,
              number_hours: null,
          }
        : { userId: null, number_hours: null };

    const [formErrors, setFormErrors] = useState(defaultErrors);
    const [formDisabled, setFormDisabled] = useState(true);
    const [requestErrors, setRequestErrors] = useState('');

    const styles = { ...multiSelectConfigs };
    const listOfRoles = listOfResources(props.roles);

    const formHasErrors = () => {
        let hasErrors = false;

        Object.values(formErrors).forEach((val) => {
            if (val !== null) {
                hasErrors = true;
            }
        });

        return hasErrors;
    };

    const formFilled = () => {
        if (isOrganisationUser()) {
            return firstName.length > 1 && lastName.length > 1 && email.length;
        }

        return !!userId;
    };

    useEffect(() => {
        setFormDisabled(formHasErrors() || !formFilled());
    }, [formErrors]);

    useEffect(() => {
        setFormDisabled(true);
    }, []);

    const clearForm = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setUserId('');
        setRolesData([]);
        setFormErrors(defaultErrors);
        setRequestErrors('');
        setFormDisabled(true);
    };

    const handleClose = () => {
        clearForm();
        props.modalElement && props.modalElement.hide();
    };

    const handleSave = () => {
        validateForm();
        if (formHasErrors()) {
            return;
        }
        if (!props.canCreate) {
            setRequestErrors($t('You do not have permission to invite a new support user.'));
            props.modalElement && props.modalElement.hide();
            clearForm();

            return;
        }

        setFormDisabled(true);
        const rolesIds = resourcesIds(rolesData);

        let data = isOrganisationUser()
            ? {
                  firstName,
                  lastName,
                  email,
                  rolesIds,
                  number_hours,
              }
            : { userId, rolesIds, number_hours };

        axios
            .post(props.inviteUrl, data)
            .then((response) => {
                props.fetchUsersHandler();
                setFormDisabled(false);
                clearForm();
                props.modalElement && props.modalElement.hide();
            })
            .catch((e) => {
                console.log(e.response);
                setRequestErrors(e.response.data.error || e.response.data.message || $t('An error occurred when inviting this user'));
                setFormDisabled(false);
            });
    };

    const firstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const hoursChange = (e) => {
        setNumberHours(e.target.value);
    };

    const lastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const emailChange = (e) => {
        setEmail(e.target.value);
    };

    const userIdChange = (e) => {
        setUserId(e.target.value);
        validateForm();
    };

    function onChangeRoles(e, option) {
        onChangeUserAssociations(e, option, setRolesData);
    }

    const validateField = (fieldName, value) => {
        const errors = { ...formErrors };
        const validationErrors = validateFormField(fieldName, value);

        Object.keys(validationErrors).forEach((key) => {
            if (key in errors) {
                errors[key] = validationErrors[key];
            }
        });

        setFormErrors(errors);
    };

    const validateForm = () => {
        if (isOrganisationUser()) {
            validateField('email', email);
            validateField('firstName', firstName);
            validateField('lastName', lastName);
        } else {
            validateField('userId', userId);
        }
        validateField('number_hours', number_hours);
    };

    return (
        <>
            <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Invite Support User')} close={handleClose}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                <div className={!requestErrors ? 'modal__form-container' : 'hidden'}>
                                    {isOrganisationUser() && (
                                        <>
                                            <FormInput
                                                horizontalLayout={true}
                                                label={$t('First Name')}
                                                required={true}
                                                type="text"
                                                id="inputSupportFirstName"
                                                placeholder={$t('First Name')}
                                                value={firstName}
                                                onChange={firstNameChange}
                                                onBlur={() => {
                                                    validateField('firstName', firstName);
                                                }}
                                                showError={formErrors.firstName}
                                                errorText={formErrors.firstName}
                                            ></FormInput>

                                            <FormInput
                                                horizontalLayout={true}
                                                label={$t('Last Name')}
                                                required={true}
                                                type="text"
                                                id="inputSupportLastName"
                                                placeholder={$t('Last Name')}
                                                value={lastName}
                                                onChange={lastNameChange}
                                                onBlur={() => {
                                                    validateField('lastName', lastName);
                                                }}
                                                showError={formErrors.lastName}
                                                errorText={formErrors.lastName}
                                            ></FormInput>

                                            <FormInput
                                                horizontalLayout={true}
                                                label={$t('Email')}
                                                required={true}
                                                type="email"
                                                id="inputSupportEmail"
                                                placeholder={$t('Email')}
                                                value={email}
                                                onChange={emailChange}
                                                onBlur={() => {
                                                    validateField('email', email);
                                                }}
                                                showError={formErrors.email}
                                                errorText={formErrors.email}
                                            ></FormInput>
                                        </>
                                    )}

                                    {!isOrganisationUser() && (
                                        <>
                                            <SelectInput horizontalLayout={true} label={$t('Users')} required={true} value={userId} onChange={userIdChange}>
                                                {!userId && <option value={''}>Select User</option>}
                                                {props.organisationUsers.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item.id}>
                                                            {item.first_name} {item.last_name}
                                                        </option>
                                                    );
                                                })}
                                            </SelectInput>
                                        </>
                                    )}

                                    <div className="tw-grid tw-grid-cols-3 tw-gap-4">
                                        <div className="tw-col-span-1">
                                            <label className="tw-text-charcoal tw-text-sm tw-mb-0">{$t('Roles')}</label>
                                        </div>
                                        <div className="tw-flex tw-col-span-2 tw-flex-col tw-space-y-1.5">
                                            <Select
                                                value={rolesData}
                                                isMulti
                                                name="roles"
                                                options={listOfRoles || []}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={onChangeRoles}
                                                styles={styles}
                                            />
                                        </div>
                                    </div>

                                    <FormInput
                                        horizontalLayout={true}
                                        label={$t('Access Hours')}
                                        required={true}
                                        type="number"
                                        id="input_number_hours"
                                        placeholder={$t('Hours')}
                                        value={number_hours}
                                        onChange={hoursChange}
                                        onBlur={() => {
                                            validateField('number_hours', number_hours);
                                        }}
                                        showError={formErrors.number_hours}
                                        errorText={formErrors.number_hours}
                                    ></FormInput>

                                    <ModalFooter
                                        cancelButtonText={$t('Close')}
                                        primaryButtonText={$t('Save')}
                                        onCancel={handleClose}
                                        handleSubmit={handleSave}
                                        allowSubmit={!requestErrors}
                                        isSubmitting={formDisabled}
                                    ></ModalFooter>
                                </div>
                                <div className={requestErrors ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                    <label className="modal__msg modal__error-text-color">{requestErrors}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
